import { Controller } from "@hotwired/stimulus"

// Typewriter effect (forward only) with cursor, then fade out.
// Usage: data-controller="typed-text" data-typed-text-words-value="Wort1|Wort2|Wort3"

export default class extends Controller {
  static values = {
    words: { type: String, default: "" },
    speed: { type: Number, default: 30 },
    pause: { type: Number, default: 3500 }
  }

  connect() {
    this.words = this.wordsValue.split("|").map(w => w.trim()).filter(Boolean)
    if (this.words.length === 0) return

    this.wordIndex = 0

    this.textSpan = document.createElement("span")
    this.cursorSpan = document.createElement("span")
    this.cursorSpan.className = "typed-text-cursor"
    this.cursorSpan.setAttribute("aria-hidden", "true")
    this.cursorSpan.textContent = "|"

    this.element.appendChild(this.textSpan)
    this.element.appendChild(this.cursorSpan)

    this.typeNext()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  typeNext() {
    const word = this.words[this.wordIndex]
    this.textSpan.textContent = ""
    this.textSpan.style.opacity = "1"
    this.cursorSpan.style.opacity = "1"
    this.element.classList.remove("typed-text-fade-out")
    let charIndex = 0

    const type = () => {
      charIndex++
      this.textSpan.textContent = word.slice(0, charIndex)

      if (charIndex < word.length) {
        this.timeout = setTimeout(type, this.speedValue)
      } else {
        // Fertig getippt – kurz warten, dann ausblenden
        this.timeout = setTimeout(() => {
          this.element.classList.add("typed-text-fade-out")
          this.element.addEventListener("animationend", () => {
            this.element.classList.remove("typed-text-fade-out")
            this.wordIndex = (this.wordIndex + 1) % this.words.length
            this.typeNext()
          }, { once: true })
        }, this.pauseValue)
      }
    }

    this.timeout = setTimeout(type, this.speedValue)
  }
}
